<template>
  <div
    class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-50"
  >
    <div
      class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
    ></div>

    <div
      class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto"
    >
      <!-- Add margin if you want to see some of the overlay behind the modal-->
      <div class="modal-content text-left">
        <!--Title-->
        <div :class="`flex justify-between items-center bg-yellow-700 p-4`">
          <p class="text-2xl font-bold text-white">
            {{ $t("production_order_detail.dialogs.export.title") }}
          </p>
          <div class="modal-close cursor-pointer z-50" @click="close">
            <svg
              class="fill-current text-white"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <path
                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
              />
            </svg>
          </div>
        </div>
        <div class="p-4">
          <!--Body-->
          <p>{{ $t("production_order_detail.dialogs.export.message") }}</p>
        </div>

        <!--Language Selection-->
        <div class="p-4">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            {{ $t("production_order_detail.dialogs.export.labels.language") }}
          </label>
          <select
            v-model="selectedLanguage"
            class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option
              v-for="locale in availableLanguages"
              :key="locale.value"
              :value="locale.value"
            >
              {{ locale.label }}
            </option>
          </select>
        </div>

        <!--Type Selection-->
        <div class="p-4">
          <label class="block text-sm font-medium text-gray-700 mb-2">
            {{ $t("production_order_detail.dialogs.export.labels.type") }}
          </label>
          <select
            v-model="selectedType"
            class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option
              v-for="type in availableTypes"
              :key="type.value"
              :value="type.value"
            >
              {{ type.label }}
            </option>
          </select>
        </div>

        <!--Footer-->
        <div class="flex justify-end p-4">
          <button
            class="px-4 bg-transparent p-3 text-blue-800 hover:bg-gray-100 hover:text-indigo-400 mr-2"
            @click="close"
          >
            {{ $t("production_order_detail.dialogs.export.buttons.close") }}
          </button>
          <button
            class="modal-close px-4 bg-blue-800 p-3 text-white hover:bg-indigo-400"
            @click="confirm"
          >
            {{ $t("production_order_detail.dialogs.export.buttons.export") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { availableLanguages } from "@/i18n";

export default {
  name: "ProductionOrderExportSelectionDialog",
  props: {
    defaultLanguage: {
      type: String,
      default: "en"
    }
  },
  data() {
    return {
      selectedLanguage: this.defaultLanguage,
      selectedType: "pdf",
      availableLanguages: availableLanguages,
      availableTypes: [
        {
          label: "PDF",
          value: "pdf"
        },
        { label: "CSV", value: "csv" }
      ]
    };
  },
  methods: {
    confirm() {
      this.$emit("confirmed", {
        language: this.selectedLanguage,
        type: this.selectedType
      });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
